<template>
  <div>
    <div class="text-left !pb-4 pt-1">
      <el-radio-group v-model="field.is_global_variable" @change="setData">
        <el-radio-button :label="false">Custom Field</el-radio-button>
        <el-radio-button :label="true">Global Variable</el-radio-button>
      </el-radio-group>
    </div>

    <el-form label-position="right" v-if="!field.is_global_variable">
      <title-and-description :field="field" />
      <el-row type="flex" :gutter="20">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="20">
        <el-col :span="12">
          <field-attributes :field="field" />
        </el-col>
        <el-col :span="12">
          <is-field-required :field="field" />
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <label
            class="field-title-label text-black-600 !text-xs 2xl:!text-sm font-normal !pb-1.5 block !mb-1"
          >
            Currency Type
          </label>
          <div class="flex items-center !gap-4">
            <el-radio
              v-model="field.validations.selected_currency_type"
              :label="false"
              @change="handleRadioChange"
              class="!m-0"
            >
              From Template
            </el-radio>
            <el-radio
              v-model="field.validations.selected_currency_type"
              :label="true"
              @change="handleRadioChange"
            >
              Standard
            </el-radio>
          </div>
          <div
            v-if="field.validations.selected_currency_type === false"
            ref="templateSelectContainer"
          >
            <el-select
              v-model="field.validations.selected_currency_field_key"
              filterable
              clearable
              @change="currencyVariable"
              class="select-input !my-1 w-full"
            >
              <el-option
                v-for="(op, i) in getCurrencyTypeFields()"
                :key="i + 'op' + op"
                :label="op.label"
                :value="op.key"
              >
                <span style="float: left">{{ op.label }}</span>
              </el-option>
            </el-select>
          </div>
          <div v-else ref="standardSelectContainer">
            <el-select
              id="currencySelect"
              v-model="field.validations.currency"
              filterable
              @change="currencyVariable"
              class="select-input my-1 w-full"
            >
              <el-option
                v-for="item in CurrencyTypes"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              >
                <span style="float: left">{{ item.value }}</span>
                <span style="float: right; color: var(--el-text-color-secondary); font-size: 13px">
                  {{ item.name }}
                </span>
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="icon-dropdown-selection flex items-center !gap-3 !py-4">
            <span
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Icon
            </span>
            <el-button type="text" @click="iconPickerdialogVisible = true" class="p-0">
              <div class="d-flex align-center menu-icon !gap-2">
                <span>
                  <icons :iconName="templateIconPath"></icons>
                </span>
                <i class="el-icon-circle-plus !text-brand-500"></i>
              </div>
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-form label-position="right" v-if="field.is_global_variable">
      <el-row type="flex" :gutter="20">
        <el-col :span="24">
          <div class="form-group">
            <el-form-item>
              <label
                class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
              >
                Global Variable
              </label>

              <el-select
                v-model="field.global_variable_id"
                @change="setGlobalVariable"
                class="!w-full"
              >
                <el-option
                  v-for="(globalVariable, index) of allGlobalVariables"
                  :key="index"
                  filterable
                  :label="globalVariable.label"
                  :value="globalVariable._id"
                >
                  <span style="float: left">{{ globalVariable.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ globalVariable.input_type }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="20">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <is-field-required :field="field" />
      <div class="mt-1"></div>
    </el-form>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
  import { fetchGlobalVariables } from '@/repo/globalVariables';
  export default {
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
      IsFieldRequired: () => import('./IsFieldRequired'),
      FieldFilledBy: () => import('./FieldFilledBy'),
      Placeholder: () => import('./Placeholder'),
      FieldAttributes: () => import('./FieldAttributes'),
    },
    props: ['field', 'fieldsData'],
    computed: {
      allGlobalVariables() {
        return this.getAllGlobalVariables ? this.getAllGlobalVariables.data || [] : [];
      },
    },
    data() {
      return {
        validations: [],
        currencyTypeFields: [],
        CurrencyTypes: [
          { value: 'USD', name: '$' },
          { value: 'CAD', name: '$' },
          { value: 'AUD', name: '$' },
          { value: 'INR', name: '₹' },
          { value: 'EUR', name: '€' },
          { value: 'MXN', name: '$' },
          { value: 'ZAR', name: 'R' },
          { value: 'MYR', name: 'RM' },
          { value: 'GBP', name: '£' },
          { value: 'AED', name: 'د.إ' },
        ],
        iconPickerdialogVisible: false,
        getAllGlobalVariables: null,
        templateIconPath: 'dashboard',
      };
    },
    mounted() {
      this.fetchGlobalVaribales();
      if (this.field && this.field.icon_name) {
        this.templateIconPath = this.field.icon_name;
      }
      if (this.field.data_table_key) {
        let dataTable = this.fieldsData.find((e) => e.key == this.field.data_table_key);
        this.currencyTypeFields = (dataTable?.data_table_columns || []).filter(
          (field) => field.inputType === 'CURRENCY_TYPE'
        );
      } else {
        this.currencyTypeFields = this.fieldsData.filter(
          (field) => field.inputType === 'CURRENCY_TYPE'
        );
      }
    },
    methods: {
      closeSelectIcon() {
        this.iconPickerdialogVisible = false;
      },
      getIconPath(icon) {
        this.templateIconPath = icon;
        this.$set(this.field, 'icon_name', icon);
        this.iconPickerdialogVisible = false;
      },
      handleRadioChange() {
        this.$nextTick(() => {
          const templateSelect =
            this.$refs.templateSelectContainer?.querySelector('.el-select input');
          const standardSelect =
            this.$refs.standardSelectContainer?.querySelector('.el-select input');
          if (this.field.validations.selected_currency_type === true) {
            this.field.validations.selected_currency_field_key = null;
            if (templateSelect) templateSelect.blur();
            if (standardSelect) standardSelect.focus();
          } else {
            this.field.validations.currency = null;
            if (this.currencyTypeFields.length === 0) {
              this.$message.info('Place the Currency Type Fields in the template');
            }
            if (standardSelect) standardSelect.blur();
            if (templateSelect) templateSelect.focus();
          }
        });
      },
      getCurrencyTypeFields() {
        return this.currencyTypeFields;
      },
      setData() {
        if (!this.field.is_global_variable) {
          this.field.options = [];
          this.field.global_variable_id = null;
        }
      },
      async fetchGlobalVaribales() {
        let params = {
          get_all: true,
          input_types: ['CURRENCY'],
        };
        this.getAllGlobalVariables = await fetchGlobalVariables(params);
      },

      setGlobalVariable() {
        let globalVariable = this.allGlobalVariables.find(
          (x) => x._id == this.field.global_variable_id
        );
        this.field.label = globalVariable.label;
        this.field.description = globalVariable.description;
        this.field.options = globalVariable.options;
        this.field.validations.currency = globalVariable.currency;
      },
      currencyVariable() {
        if (this.field.validations.currency == 'INR') {
          this.field.validations.locale = 'en-IN';
        } else if (this.field.validations.currency == 'USD') {
          this.field.validations.locale = 'en-US';
        } else if (this.field.validations.currency == 'CAD') {
          this.field.validations.locale = 'en-CA';
        } else if (this.field.validations.currency == 'MXN') {
          this.field.validations.locale = 'es-MX';
        } else if (this.field.validations.currency == 'ZAR') {
          this.field.validations.locale = 'en-ZA';
        } else if (this.field.validations.currency == 'MYR') {
          this.field.validations.locale = 'ms-MY';
        } else if (this.field.validations.currency == 'GBP') {
          this.field.validations.locale = 'en-GB';
        } else if (this.field.validations.currency == 'AED') {
          this.field.validations.locale = 'ar-AE';
        } else {
          this.field.validations.locale = 'en-IE';
        }
      },
    },
  };
</script>

<style lang="scss">
  .currency:before {
    content: '*';
    color: red;
    position: absolute;
    margin-left: 107px;
    margin-top: 4px;
  }
</style>
<style lang="scss" scoped>
  .form-items-row {
    display: flex;
    justify-content: space-between;
  }

  .form-item-col {
    display: flex;
    flex-direction: column;
  }

  .select-input {
    width: 48%;
  }
</style>
